// src/modules/app-views/crm/pages/Boards/modals/BoardSettingsModal/tabs/HolidaysTab.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState } from 'react';
import { Button, DatePicker, Flex, Input, Tag } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const HolidaysTab = ({ holidays, setHolidays }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [pickedDate, setPickedDate] = useState(null);
  const [description, setDescription] = useState('');

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleAdd = () => {
    if (!pickedDate) return;
    const date = pickedDate.format('YYYY-MM-DD');
    // Prevent duplicate dates
    if (holidays.some(h => h.date === date)) return;
    setHolidays(prev =>
      [...prev, { date, description: description.trim() }].sort((a, b) =>
        a.date.localeCompare(b.date),
      ),
    );
    setPickedDate(null);
    setDescription('');
  };

  const handleDelete = date => {
    setHolidays(prev => prev.filter(h => h.date !== date));
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="mt-3">
      {/* Add holiday row */}
      <Flex gap={8} style={{ marginBottom: 16 }}>
        <DatePicker
          value={pickedDate}
          onChange={setPickedDate}
          format="DD/MM/YYYY"
          style={{ width: 150 }}
          placeholder={translateX('date')}
        />
        <Input
          value={description}
          onChange={e => setDescription(e.target.value)}
          placeholder={translateX('description_optional')}
          onPressEnter={handleAdd}
          style={{ flex: 1 }}
        />
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAdd}
          disabled={!pickedDate}
        >
          {translateX('add')}
        </Button>
      </Flex>

      {/* Holiday list */}
      {holidays.length === 0 ? (
        <div
          className="text-muted"
          style={{ textAlign: 'center', padding: '24px 0', fontSize: 13 }}
        >
          {translateX('no_holidays_registered')}
        </div>
      ) : (
        <Flex vertical gap={8}>
          {holidays.map(h => (
            <Flex
              key={h.date}
              justify="space-between"
              align="center"
              style={{
                padding: '8px 12px',
                borderRadius: 6,
                border: '1px solid #f0f0f0',
                background: '#fafafa',
              }}
            >
              <Flex align="center" gap={10}>
                <Tag color="red" style={{ margin: 0 }}>
                  {dayjs(h.date).format('DD/MM/YYYY')}
                </Tag>
                <span style={{ fontSize: 13 }}>{h.description || '—'}</span>
              </Flex>
              <Button
                type="text"
                size="small"
                danger
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(h.date)}
              />
            </Flex>
          ))}
        </Flex>
      )}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default HolidaysTab;
